import React from 'react';
import Splash from './Splash.jsx';
import Header from './Header.jsx';
import Aside from './Aside.jsx';
import Category from './Category.jsx';
import Product from './Product.jsx';
import About from './About.jsx';
import Basket from './Basket.jsx';
import Footer from './Footer.jsx';
import { HashRouter as Router, Switch, Route, Link, hashHistory} from "react-router-dom";

import classic from '../db/decorative.js';
import decorative from '../db/classic.js';
import pots from '../db/pots.js';
import {BuildGood} from '../db/db.js';

export default class App extends React.Component{
	constructor(props){
		super(props);
		this.state={
			burgOpen: false
		};
		this.changeBurger=this.changeBurger.bind(this);
		this.renderProduct=this.renderProduct.bind(this);
	}
	changeBurger(){
		this.setState({burgOpen:!this.state.burgOpen})
	}
	renderProduct(props){
		let urlCategory=props.match.params.category;
		const urlProduct=props.match.params.id;
		switch(urlCategory) {
			case 'classic':
				urlCategory=decorative;
				break;
			case 'decorative':
				urlCategory=classic;
				break;
			case 'pots':
				urlCategory=pots;
				break;
		}
		urlCategory.forEach((i,n) =>{
			if(i[0]==urlProduct){
				this.product = new BuildGood(i);
			};
		});
		return <Product product={this.product}/>
	}
	render(){
		return(
			<Router>
				<React.Fragment>
					<Splash/>
					<Aside changeBurg={this.changeBurger} burgOpen={this.state.burgOpen}/>
					<div id='wrapper' className={this.state.burgOpen?'active':null}>
						<Switch>
							<Route exact path='/' component={Header}/>
							<Route exact path='/:category/:id' render={(props) =>this.renderProduct(props)}/>
							<Route exact path='/pots' render={(props) =><Category match={props} category={pots}/>}/>
							<Route exact path='/classic' render={(props) =><Category match={props} category={decorative}/>}/>
							<Route exact path='/decorative' render={(props) =><Category match={props} category={classic}/>}/>
							<Route exact path='/about' component={About}/>
							<Route exact path='/contact' component={Footer}/>
							<Route exact path='/purchase' component={Basket}/>
						</Switch>
					</div>
				</React.Fragment>
			</Router>
		)
	}
}